﻿"use strict";


function showPriceData(numberOfItemsElementId, price) {
	var priceText = '';

	if (price) {
		if (price.InsteadOfGrossPrice && price.InsteadOfGrossPrice > price.GrossPrice) {
			priceText += '<del>' + price.Currency + '&nbsp;' + GlobalizeEx.formatAmountSafe(price.InsteadOfGrossPrice) + '</del><br>';
		}
		priceText += price.Currency + '&nbsp;' + GlobalizeEx.formatAmountSafe(price.GrossPrice);
	}
	$('#' + numberOfItemsElementId + '_Price').html(priceText);

	if (price && price.InsteadOfGrossPrice > price.GrossPrice && price.ValidTo) {
		$('#' + numberOfItemsElementId + '_ValidTo').html(GlobalizeEx.formatDateSafe(price.ValidTo));
	} else {
		$('#' + numberOfItemsElementId + '_ValidTo').html('');
	}
}

// For the dropdown when selection is made from it
function registerNumberOfItemsSelectionChanged(selectedItemPriceElementId, numberOfItemsElementId, prices) {
	$('#' + selectedItemPriceElementId).change(function () {
		var price = null;

		var val = $(this).val();
		if (val) {
			price = prices[String(val)];
		}
		showPriceData(numberOfItemsElementId, price);
	});
}

// For the text box when the number of items is entered in it
function registerNumberOfItemsValueChanged(numberOfItemsElementId, prices) {
	var priceCalculator = new PriceCalculator(prices);
	$('#' + numberOfItemsElementId).on('input', function () {
		var price = null;
		var val = $(this).val();
		try {
			var numberOfItems = parseInt(val);
			var price = priceCalculator.calculatePriceForNumberOfItems(numberOfItems);
		} catch (err) {
		}

		showPriceData(numberOfItemsElementId, price);
	});
}